module.exports = __webpack_public_path__ + "img/logo-small.da79e2e5.png";